export default __webpack_public_path__ + "static/media/madame_detail19.2b4d26ba.jpg";